// 钉钉二维码登录
import React, { useEffect, useRef } from 'react';
import qs from 'qs';

import { dingdingConfigs, getEnv } from '@/config';

import styles from './index.module.scss';

const DingTalkAuthURL = dingdingConfigs.authUrl;
const DingTalkAuthKey = dingdingConfigs[getEnv()].AppKey;
const DingTalkCallbackURL = `${window.location.origin}/authorization/ding-talk`;

const Index = () => {
  const iframeRef = useRef<HTMLIFrameElement>();

  // 初始化钉钉扫码登录
  const initQrCode = () => {
    const gotoUrl = `${DingTalkAuthURL}?appid=${DingTalkAuthKey}&redirect_uri=${DingTalkCallbackURL}&response_type=code&scope=snsapi_login&state=STATE`;
    const iframe = document.createElement('iframe');
    iframe.src = `https://login.dingtalk.com/login/qrcode.htm?goto=${window.encodeURIComponent(
      gotoUrl,
    )}&style=${window.encodeURIComponent('border:none;background-color:#FFFFFF;margin-top:-40px')}`;
    iframe.className = styles.DingTalkAuthFrame;
    iframeRef.current.appendChild(iframe);
  };

  // 扫码回调（获取 loginTmpCode）
  const handleMessage = (event) => {
    const { origin } = event;
    if (origin === 'https://login.dingtalk.com') {
      const loginTmpCode = event.data;
      // 跳转到钉钉的校验链接
      if (loginTmpCode) {
        const url = `${DingTalkAuthURL}?appid=${DingTalkAuthKey}&redirect_uri=${DingTalkCallbackURL}&loginTmpCode=${loginTmpCode}&response_type=code&scope=snsapi_login&state=STATE`;
        window.location.href = url;
      }
    }
  };

  // 授权回调
  const getAuthCallbackCode = () => {
    try {
      const params = qs.parse(window.location.search, { ignoreQueryPrefix: true });
      if (params && params.code) {
        window.top.postMessage(
          { source: 'DingTalkAuthCallback', payload: { code: params.code } },
          '*',
        );
      }
    } catch (e) {
      //
    }
  };

  useEffect(() => {
    getAuthCallbackCode();
    initQrCode();
    // 监听扫码的消息
    window.addEventListener('message', handleMessage, false);

    return () => {
      // 移除监听事件
      window.removeEventListener('message', handleMessage, false);
    };
  }, []);

  return <div ref={iframeRef} className={styles.DingTalkAuthWrapper} />;
};

export default Index;
